export const SAVED_SEARCH_BOILER_PLATE = {
  param_version: 1,
  filter_version: 0,
  data_source_code: 'MORPHEUS',
  email_alert_type: 'DAILY',
  subscribed_to_notifications: false,
}

export const SAVED_SEARCH_TYPES = {
  GLOBAL: 'GLOBAL',
  PERSONAL: 'PERSONAL',
}
